import { Button } from '@7f-ui/components/button/button'
import { trackCtaButton } from '@feat/feat-tracking/cta-button'
import { Backpack } from '@phosphor-icons/react'

import { shopTestId } from '@utils/utils-shop-test-ids'
import Link from 'next/link'

type Config = {
  isScrollTop: boolean
  isHomePage: boolean
  isHomePageScrolledToTop: boolean
}

type MerchantCTAProps = {
  config?: Config
}

export function MerchantCTA({ config }: MerchantCTAProps) {
  return (
    <Button
      as={Link}
      classNames={{ root: 'hidden md:inline-flex' }}
      variant={config?.isHomePageScrolledToTop ? 'secondary' : 'text'}
      onDarkBg={!config?.isHomePageScrolledToTop}
      href="/lp/guide-werden/"
      data-testid={shopTestId('Header.becomeAMerchant')}
      IconStart={Backpack}
      onClick={() => trackCtaButton('offer experience')}
    >
      Erlebnis anbieten
    </Button>
  )
}
